export default function CCCollectionPointSidebarIcon() {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 11.1075V16.4521C3.75 16.6179 3.81585 16.7769 3.93306 16.8941C4.05027 17.0113 4.20924 17.0771 4.375 17.0771H15.625C15.7908 17.0771 15.9497 17.0113 16.0669 16.8941C16.1842 16.7769 16.25 16.6179 16.25 16.4521V11.1076M17.5 7.70215V8.95215C17.5 9.61519 17.2366 10.2511 16.7678 10.7199C16.2989 11.1888 15.663 11.4521 15 11.4521C14.337 11.4521 13.7011 11.1888 13.2322 10.7199C12.7634 10.2511 12.5 9.61519 12.5 8.95215M17.5 7.70215L16.3795 3.78045C16.3422 3.64985 16.2634 3.53497 16.1549 3.45318C16.0465 3.37139 15.9144 3.32715 15.7786 3.32715H4.22144C4.08562 3.32715 3.9535 3.37139 3.84507 3.45318C3.73664 3.53497 3.6578 3.64985 3.62049 3.78045L2.5 7.70215M17.5 7.70215H2.5M12.5 8.95215V7.70215M12.5 8.95215C12.5 9.61519 12.2366 10.2511 11.7678 10.7199C11.2989 11.1888 10.663 11.4521 10 11.4521C9.33696 11.4521 8.70107 11.1888 8.23223 10.7199C7.76339 10.2511 7.5 9.61519 7.5 8.95215M7.5 8.95215V7.70215M7.5 8.95215C7.5 9.61519 7.23661 10.2511 6.76777 10.7199C6.29893 11.1888 5.66304 11.4521 5 11.4521C4.33696 11.4521 3.70107 11.1888 3.23223 10.7199C2.76339 10.2511 2.5 9.61519 2.5 8.95215V7.70215"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
